import moment from "moment";
import {mondays} from "../utils/calendar";
import {minWeek} from "../utils/calendar";

export const plan = {
    data() {
        return {
            milestones: [],
            range: {
                start: '2019-01',
                end: '2019-12'
            },
            mode: null
        }
    },
    methods: {
        getMilestone(taskId, week) {
            return this.milestones.filter(ms => ms.week === week && ms.taskId === taskId)[0];
        },
        hasMilestone(taskId, week) {
            return this.milestones.some(ms => ms.week === week && ms.taskId === taskId);
        },
        milestoneStatusEquals(taskId, week, status) {
            return this.hasMilestone(taskId, week) && this.getMilestone(taskId, week).status === status;
        },
        milestoneStatusIsNull(taskId, week) {
            return this.hasMilestone(taskId, week) && !this.getMilestone(taskId, week).status;
        },
        milestoneStatusIsNotNull(taskId, week) {
            return this.hasMilestone(taskId, week) && this.getMilestone(taskId, week).status;
        },
        changeMode(mode) {
            this.mode = mode;
        }
    },
    computed: {
        months() {
            let startDate = moment(this.range.start);
            let endDate = moment(this.range.end);

            let result = [];
            if (endDate.isBefore(startDate)) {
                return result;
            }

            while (startDate.isSameOrBefore(endDate)) {
                result.push({
                    month: startDate.format("YYYYMM"),
                    weeks: mondays(startDate.year(), startDate.month())
                });
                startDate.add(1, 'month');
            }
            return result;
        },
        weeks() {
            let result = [];
            for (let month of this.months) {
                for (let i = 1; i <= month.weeks; i++) {
                    result.push(month.month + i);
                }
            }
            return result;
        }
    }
};